import React, { useMemo } from 'react'
import { Field, Form, Formik, getIn } from 'formik'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@material-ui/core'
import { Close as CloseIcon } from '@material-ui/icons'

import { DraggablePaper, OutlinedButton, ContainedButton } from 'civic-champs-shared'
import StyledOutlinedTextField from 'civic-champs-shared/formik/components/StyledOutlinedTextField'
import { useStyles } from 'components/FormModal'
import { SubscriptionDetails, SubscriptionDetailValues } from 'organization/types'

interface SubscriptionInfoModalProps {
  subDetails: SubscriptionDetails | null
  showing: boolean
  close: () => void
  complete: (values: SubscriptionDetailValues) => Promise<void>
}

const SubscriptionInfoModal = (props: SubscriptionInfoModalProps) => {
  const { subDetails, showing, close, complete } = props

  const initialValues = useMemo(
    () =>
      ({
        pricingTier: getIn(subDetails, 'pricingTier', ''),
        startDate: getIn(subDetails, 'startDate', ''),
        endDate: getIn(subDetails, 'endDate', ''),
        renewalStatus: getIn(subDetails, 'renewalStatus', ''),
        renewalRate: getIn(subDetails, 'renewalRate', ''),
        notes: getIn(subDetails, 'notes', ''),
      } as SubscriptionDetailValues),
    [subDetails],
  )

  const classes = useStyles()

  return (
    <Dialog
      open={showing}
      PaperComponent={DraggablePaper}
      // @ts-ignore
      PaperProps={{ handle: `#sub-info-modal` }}
      aria-labelledby="draggable-dialog-title"
      maxWidth="xs"
      classes={{ paper: classes.dialog }}
      disableEnforceFocus
    >
      <Formik initialValues={initialValues} onSubmit={complete}>
        {formik => (
          <>
            <DialogTitle classes={{ root: classes.title }} disableTypography={true} id="sub-info-modal">
              Edit Subscription Information
              <IconButton className={classes.dialogCloseButton} onClick={() => close()}>
                <CloseIcon className={classes.dialogCloseIcon} />
              </IconButton>
            </DialogTitle>
            <DialogContent classes={{ root: classes.content }}>
              <Form>
                <Field
                  component={StyledOutlinedTextField}
                  id="pricingTier"
                  name="pricingTier"
                  label="Pricing Tier"
                  variant="outlined"
                  fullWidth
                />
                <Field
                  component={StyledOutlinedTextField}
                  id="startDate"
                  name="startDate"
                  label="Start Date"
                  variant="outlined"
                  fullWidth
                />
                <Field
                  component={StyledOutlinedTextField}
                  id="endDate"
                  name="endDate"
                  label="End Date"
                  variant="outlined"
                  fullWidth
                />
                <Field
                  component={StyledOutlinedTextField}
                  id="renewalStatus"
                  name="renewalStatus"
                  label="Renewal Status"
                  variant="outlined"
                  fullWidth
                />
                <Field
                  component={StyledOutlinedTextField}
                  id="renewalRate"
                  name="renewalRate"
                  label="Renewal Rate"
                  variant="outlined"
                  fullWidth
                />
                <Field
                  component={StyledOutlinedTextField}
                  id="notes"
                  name="notes"
                  label="Notes"
                  variant="outlined"
                  fullWidth
                />
              </Form>
            </DialogContent>
            <DialogActions className={classes.actions}>
              <OutlinedButton className={classes.back} disabled={formik.isSubmitting} onClick={close}>
                Cancel
              </OutlinedButton>
              <ContainedButton className={classes.next} disabled={formik.isSubmitting} onClick={formik.submitForm}>
                Save
              </ContainedButton>
            </DialogActions>
          </>
        )}
      </Formik>
    </Dialog>
  )
}

export default SubscriptionInfoModal
